//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    projectId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    currentProjectId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isActive: this.projectId === this.currentProjectId,
      items: [
        {
          label: 'Detalle de proyecto',
          path: `/mis-proyectos/${this.projectId}`,
        },
        {
          label: 'Supervisores',
          path: `/mis-proyectos/${this.projectId}/supervisores`,
        },
        {
          label: 'Colaboradores',
          path: `/mis-proyectos/${this.projectId}/colaboradores`,
        },
        {
          label: 'Inventario de habilidades',
          path: `/mis-proyectos/${this.projectId}/inventario-habilidades`,
        },
        {
          label: 'Potencial de match',
          path: `/mis-proyectos/${this.projectId}/potencial-match`,
        },
        {
          label: 'Empleabilidad y productividad',
          path: `/mis-proyectos/${this.projectId}/empleabilidad-productividad`,
        },
        {
          label: 'Validación de jefatura',
          path: `/mis-proyectos/${this.projectId}/validacion-jefatura`,
        },
      ],
    }
  },
  watch: {
    currentProjectId(newVal) {
      this.isActive = this.projectId === newVal
    },
  },
  methods: {
    handleClick(to) {
      this.$emit('click')
      this.$router.push(to)
    },
  },
}
